export default __webpack_public_path__ + "static/media/electron.ce442d22.jpg";